<template>
  <datasource-dropdown
    :datasource="datasource"
    :label="i18n"
    search="libelle"
    field="libelle"
    :additionalField="additionalField"
    @cleared="resetForm"
    :value="enumEntityValue"
    @input="input"
    :validation="validation"
    :serverSearch="serverSearch"
    :readonly="readonly"
    :disabled="disabled"
    :saveable="saveable"
    :defaultValue="defaultValue"
    :clearable="clearable"
    ref="dsDropDown"
  />
</template>

<script>
import Datasource from '@/utils/datasource';
import { convertToKebabCase } from '@/utils/string';

export default {
  props: {
    i18n: String,
    value: Object,
    namespace: String,
    additionalField: Array,
    validation: Object,
    searchActif: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    serverSearch: {
      type: Boolean,
      default: false,
    },
    saveable: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: Object,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    sortBy: {
      type: String,
      default: 'id',
    },
  },
  data() {
    let namespace = this.namespace;
    if (
      !namespace.startsWith('staticenum/') &&
      !namespace.startsWith('abstractenum/')
    ) {
      namespace = 'abstractenum/' + namespace;
    }
    const datasource = new Datasource(convertToKebabCase(namespace), {
      sortBy: this.sortBy,
      args: { actif: this.searchActif ? true : null },
    });

    return {
      datasource,
      enumEntityValue: this.value,
    };
  },
  watch: {
    value(val) {
      this.enumEntityValue = val;
    },
  },
  methods: {
    resetForm() {
      this.$emit('input', null);
    },
    input(event) {
      this.enumEntityValue = event;
      this.$emit('input', event);
    },
  },
};
</script>
